import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../assets/locales/en_EN.json';
import fr from '../assets/locales/fr_FR.json';
import es from '../assets/locales/es_ES.json';
import de from '../assets/locales/de_DE.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('lang') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;